import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AppBarPortal from '../components/AppBarPortal';
import AppLeftPortal from '../components/AppLeftPortal';
import AppFooterPortal from '../components/AppFooterPortal';

const styles = {
  pl: {
    paddingLeft: 25
  }
}

class VolunteerConsent extends React.PureComponent {

  state = {
    title: 'CONSENTIMIENTO DE PARTICIPACIÓN EN ESTUDIOS DE COSMOCARE'
  }

  componentDidMount() {
    document.body.classList.add("login");
    document.title = this.state.title + ' - CosmoCare';
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    return (
      <main style={{ display: 'block', padding: 25 }}>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}
        
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='headline' align='center' paragraph>
              CONSENTIMIENTO DE PARTICIPACIÓN EN ESTUDIOS DE COSMOCARE
            </Typography>
            <Typography paragraph>
              CosmoCare me propone formar parte de su base de datos de voluntarios y participar en sus pruebas de 
              evaluación de la seguridad y la eficacia de productos cosméticos. Una vez registrado como voluntario 
              en la base de datos, CosmoCare ofrecerá propuestas para participar en estudios con productos de 
              investigación cosméticos específicos que podrán ser aceptadas o rechazadas. Soy consciente de que
               soy completamente libre de aceptar la propuesta o rechazarla.
            </Typography>
            <Typography paragraph>
              Me comprometo a realizar los test a conciencia, siguiendo las indicaciones, leyendo atentamente los 
              cuestionarios y formularios, preguntando en el caso de duda y contestando de manera veraz.
            </Typography>
            <Typography paragraph variant="subheading">
              CONFIDENCIALIDAD
            </Typography>
            <Typography paragraph>
              En calidad de miembro del panel de voluntarios CosmoCare, soy consciente de que recibiré productos e 
              información de diferentes empresas y que la información relativa a estos estudios es estrictamente 
              confidencial. Me comprometo, en consecuencia, a mantener bajo estricta confidencialidad dichos productos 
              e información. 
            </Typography>
            <Typography paragraph variant="subheading">
              PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL
            </Typography>
            <Typography paragraph>
              De conformidad con la normativa vigente en materia de protección de datos, sus datos serán tratados por 
              COSMOCARE EXPERT, SOCIEDAD LIMITADA, con NIF B67255455 y domicilio social en Calle Diputación, núm. 180, 
              6ª planta Oficinas B-C, 08011 Barcelona (en adelante, “CosmoCare”), con las finalidades de inclusión de 
              los sujetos en la base de voluntarios de CosmoCare para la realización de estudios con productos de investigación 
              cosméticos, así como para la gestión de trámites derivados de dichos estudios. Asimismo, trataremos sus datos de 
              salud, tales como los relativos a alergias, enfermedades graves que padezca o medicación con la única finalidad 
              de reafirmar que las pruebas de evaluación de la aceptabilidad de productos cosméticos no supongan un menoscabo 
              o riesgo para su salud. La negativa a suministrar sus datos personales para estas finalidades supondrá la 
              imposibilidad de realización de dichos estudios.
            </Typography>
            <Typography paragraph>
              La legitimación del tratamiento de los datos obtenidos es su consentimiento. Sus datos 
              podrán ser comunicados a la Agencia Española de Medicamentos y Productos Sanitarios para 
              las finalidades de cosmetovigilancia. Los datos obtenidos serán conservados durante el 
              tiempo necesario para la realización de las finalidades para las que fueron recogidos 
              y atención a las posibles responsabilidades derivadas de las mismas, salvo que el usuario 
              solicite su baja a CosmoCare, se oponga o revoque su consentimiento. Asimismo, en el 
              supuesto de facilitar datos de terceros, manifiesta contar con el consentimiento de los 
              mismos y se compromete a trasladarle la información contenida en esta cláusula. Usted 
              podrá ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación 
              y portabilidad, así como de retirar su consentimiento, mediante el email contact@cosmocare.eu 
              o correo postal, en la dirección Calle Diputación, núm. 180, 6ª planta Oficinas B-C, 08011 
              Barcelona. Si considera que CosmoCare ha vulnerado los derechos que le son reconocidos por 
              la normativa aplicable en protección de datos podrá reclamar ante la Agencia Española 
              de Protección de Datos.
            </Typography>
            <Typography paragraph>
              Me comprometo a no participar al mismo tiempo en otros estudios con productos cosméticos, ya sea 
              con CosmoCare o con otro centro de estudios de actividad similar.
            </Typography>
            <Typography paragraph>
              Puedo solicitar, en todo momento, información complementaria a CosmoCare en el +34 93 737 64 00 
              durante los horarios de apertura o por correo electrónico en la dirección contact@cosmocare.eu
            </Typography>
            <Typography paragraph>
              <strong>
                MEDIANTE LA MARCACIÓN DE LA CASILLA CORRESPODIENTE, USTED ACEPTA FORMAR PARTE DE LA BASE DE DATOS DE 
                VOLUNTARIOS DE COSMOCARE, RESPETANDO LAS CONDICIONES DE USO FACILITADAS Y EN TÉRMINOS ESTABLECIDOS 
                EN LA PRESENTE CLÁUSULA INFORMATIVA.
              </strong>
            </Typography>
          </Grid>
        </Grid>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles)(VolunteerConsent)
  )
);


// WEBPACK FOOTER //
// ./src/modules/shared/pages/VolunteerConsent.js